export default __webpack_public_path__ + "static/media/mainMobile.17bad004.png";